<template>
  <div class="page-content-wrapper">
    <div class="page-content sdkapp">
      <!-- BEGIN PAGE HEADER-->
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <i class="fa fa-home"></i>
            <a href="index.html">首页</a>
            <i class="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">地址</a>
          </li>
        </ul>
      </div>
      <!-- END PAGE HEADER-->
      <div id="search-bar">
        <input
          type="text"
          placeholder="查询第一级地址名称"
          class="form-control search-bar-item"
          name="name"
          v-model="name"
        />
        <button type="button" class="btn blue search-bar-item" @click="search">
          查询
          <i class="fa fa-search"></i>
        </button>
        <button type="button" class="btn green search-bar-item" @click="sync">
          同步
          <i class="fa fa-refresh"></i>
        </button>
      </div>

      <tree-table :headers="headers" :rows="addrs"></tree-table>

      <div id="pager-bar">
        <pager
          :page-index="pageIndex"
          :page-size="pageSize"
          :total-count="totalCount"
          :action="query"
          @page-change="onPageChange"
        ></pager>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../lib/utils/request.js'
import commonMethods from '../lib/methods/common.js'
import Pager from './fragment/Pager.vue'
import TreeTable from './fragment/TreeTable.vue'
// import BootstrapModal from '../fragment/BootstrapModal.vue'
import { MSG_ID, K_LOGINED_USER } from '../lib/constant'
import { mapState } from 'vuex'
// let moment = require('moment')
import mixins from '../mixins'
import db from '../store/local'

export default {
  mixins: mixins,
  name: 'lock-addr',
  data () {
    return {
      addrs: [],
      willRemoved: new Set(),
      // 列表分页用数据
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      headers: ['', '小区'],
      community: '',
      name: ''
    }
  },
  components: {
    // BootstrapModal,
    Pager,
    TreeTable
  },
  mounted () {
    this.query()
    window.emitter.emit(MSG_ID.MSG_UI_INFLATE_SELECT2, '#test-id')
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    search () {
      // uncheck all
      // this.uncheckAll()
      this.resetPager()
      this.query()
    },
    query () {
      let that = this
      let reqdata = {
        page_index: this.pager.pageIndex,
        page_size: this.pageSize,
        name: this.name,
        fetch: 1,
        uid: db.get(K_LOGINED_USER).account.id,
        parent_addr_id: '0'
      }
      http.post('addr.pageAddr', reqdata, { session: this.session() }, function (data) {
        that.addrs = data.content
        that.totalCount = data.total_count
      }, (res) => {
        console.log(res)
      })
      // if (window.$('#filterName').val() !== '') {
      //   window.$('table tbody tr').hide().filter(":contains('" + (window.$('#filterName').val()) + "')").show()
      // }
      // console.log(window.$('table tbody'))
    },
    onSuccessEditApp () {
      this.hideModal()
      this.query()
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_SYS_NAVIGATION_PUSH, { path: 'appdetail', query: { appId: id } })
    },
    // remove (id) {
    //   console.log('delete ' + id)
    //   window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除app信息', () => {
    //     let reqdata = {action: 2, id: id}
    //     http.post('adv.setApp', reqdata, {}, this.query, () => {})
    //   })
    // },
    // multiRemove () {
    //   if (this.willRemoved.size < 1) {
    //     window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '请选中需要批量删除的APP')
    //   } else {
    //     window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '批量删除app信息', () => {
    //       let reqdata = {action: 2, _ids: [...this.willRemoved]}
    //       http.post('adv.setApp', reqdata, {}, this.query, () => {})
    //     })
    //   }
    // },
    // changeCheckbox (event, type, val) {
    //   switch (type) {
    //     case 0: {
    //       let all = window.$('input[name="check-item"]')
    //       if (event.target.checked) {
    //         all.each((i, elem) => {
    //           this.willRemoved.add(+elem.id)
    //           elem.checked = true
    //         })
    //       } else {
    //         this.willRemoved.clear()
    //         all.each((i, elem) => {
    //           elem.checked = false
    //         })
    //       }
    //       break
    //     }
    //     case 1: {
    //       if (event.target.checked) {
    //         this.willRemoved.add(+val)
    //       } else {
    //         this.willRemoved.delete(+val)
    //       }
    //     }
    //   }
    // },
    // hideModal () {
    //   window.$('#sdkapp-edit').modal('hide')
    // },
    // uncheckAll () {
    //   window.$('input[name="check-item"]').prop('checked', false)
    //   window.$('input[name="check-title"]').prop('checked', false)
    // },
    sync () {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '将从科耐系统中同步楼栋信息，需要一段时间，且不能中断', () => {
        this.showLopeLoading()
        this.doSync()
      })
    },
    doSync () {
      let reqdata = {}
      http.post('addr.sync', reqdata, {}, () => {
        this.hideLopeLoading()
        window.emitter.emit(MSG_ID.MSG_UI_TIP_SUCC, '地址数据同步成功')
        this.query()
      }, (res) => {
        console.log(res)
      })
    },
    ...commonMethods
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sdkapp {
  background-color: #fff;
}
#search-bar {
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#pager-bar {
  text-align: center;
}
.search-bar-item {
  flex-grow: 1;
}
.table th {
  text-align: center;
}

@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// Addr.vue?4f990734